import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { loginEmergent } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const hasProcessed = React.useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/admin/login"); return; }
    (async () => {
      try {
        await loginEmergent(m[1]);
        window.history.replaceState({}, "", "/admin");
        nav("/admin");
      } catch (e) { setError("Connexion échouée"); nav("/admin/login"); }
    })();
  }, [location, loginEmergent, nav]);

  return (
    <div className="min-h-screen grid place-items-center bg-deep-blue text-ivory">
      <div className="text-center">
        <div className="font-display text-3xl">Connexion en cours…</div>
        {error && <div className="text-warm-orange mt-2">{error}</div>}
      </div>
    </div>
  );
}
